<div class="sucess-box">
    <h2 class="case-study-text">Success Story</h2>
    <section class="sucess-story py-3">
        <div class="container">
            <div class="row">
                <ion-slides pager="false" [options]="slidesSuccess" #slides>
                    <ion-slide class="inside-sl-box">
                        <div class="casestudy-single" 
                            style=" visibility: visible; ">
                            <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/cynthia-rawley.jpg?alt=media&token=430332c6-52a4-449a-837c-95ce2d99b134"
                                class="casestudy1" alt="cynthia-rawley" title="cynthia-rawley">
                            <a class="read-more" routerLink="/case-studies/cynthia-rowley.html"
                                href="/case-studies/cynthia-rowley"><span class="btn-text">Cynthia Rowley </span><span
                                    class="btn-arrow"><i class="fa fa-long-arrow-right"></i></span></a>

                            <div class="text">
                                <h4><img src="assets/images/home-new/cynthiarowley.svg" alt="Cynthia Rowley"
                                    title="cynthiarowley"
                                        class="logo-brands">
                                </h4>
                                <!-- <span>ecommerce website </span> -->
                                <h3 class="card-heading"><a routerLink="/case-studies/cynthia-rowley.html"
                                        href="/case-studies/cynthia-rowley">Cynthia Rowley
                                    </a></h3>
                            </div>
                        </div>
                    </ion-slide>


                    <ion-slide class="inside-sl-box">
                        <div class="casestudy-single " 
                            style="visibility: visible; ">
                            <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Untitled%20design%20(1).jpg?alt=media&token=56c9448c-c7a1-47d7-b111-d9347eef7516"
                                class="casestudy1" alt="Lockwood Umbrellas">
                            <a class="read-more" routerLink="/case-studies/lockwood-umbrellas.html"
                                href="/case-studies/lockwood-umbrellas"><span class="btn-text">Lockwood
                                    Umbrellas</span><span class="btn-arrow"><i
                                        class="fa fa-long-arrow-right"></i></span></a>

                            <div class="text">
                                <h4><img src="assets/images/home-new/lockwood.png" alt="Lockwood Umbrellas" title="lockwood"
                                        class="logo-brands">
                                </h4>
                                <!-- <span>ecommerce website </span> -->
                                <h3 class="card-heading"><a routerLink="/case-studies/lockwood-umbrellas.html"
                                        href="/case-studies/lockwood-umbrellas">Lockwood Umbrellas
                                    </a></h3>
                            </div>
                        </div>
                    </ion-slide>


                    <ion-slide class="inside-sl-box">
                        <div class="casestudy-single " 
                            style="visibility: visible; ">
                            <img src="assets/images/2021322112617-868ramybrook-bg.jpg"
                                class="casestudy1" alt="ramybrook" title="ramybrook">
                            <a class="read-more" routerLink="/case-studies/love-bonito.html" href="/casestudy-details"><span
                                    class="btn-text">Love Bonito </span><span class="btn-arrow"><i
                                        class="fa fa-long-arrow-right"></i></span></a>

                            <div class="text">
                                <h4><img src="assets/images/home-new/lovebonito.png" alt="love bonito"    title="lovebonito"
                                        class="logo-brands">
                                </h4>
                                <!-- <span>ecommerce website </span> -->
                                <h3 class="card-heading"><a routerLink="/case-studies/love-bonito.html"
                                        href="/case-studies/love-bonito">Love Bonito
                                    </a></h3>
                            </div>
                        </div>
                    </ion-slide>


                    <ion-slide class="inside-sl-box">
                        <div class="casestudy-single " 
                            style="visibility: visible; ">
                            <img src="assets/images/home-new/202315232349-36slide11-3.jpg" class="casestudy1"
                                alt="iLastword">
                            <a class="read-more" routerLink="/case-studies/ilastword.html" href="/casestudy-details"><span
                                    class="btn-text">iLastword Story </span><span class="btn-arrow"><i
                                        class="fa fa-long-arrow-right"></i></span></a>

                            <div class="text">
                                <h4><img src="assets/images/home-new/ilastword.png" alt="iLastword" class="logo-brands" title="ilastword">
                                </h4>
                                <!-- <span>social media platform</span> -->
                                <h3 class="card-heading"><a routerLink="/case-studies/ilastword.html"
                                        href="/casestudy-details"> iLastword</a></h3>
                            </div>
                        </div>
                    </ion-slide>


                    <ion-slide class="inside-sl-box">
                        <div class="casestudy-single " 
                            style="visibility: visible; ">
                            <div>
                                <img src="assets/images/home-new-img/girl-with-dog_optimized_100.jpg"
                                    class="casestudy1" alt="Pets and Joys">
                            </div>
                            <a class="read-more" routerLink="/case-studies/pets-and-joys.html"
                                href="/case-studies/pets-and-joys"><span class="btn-text">Pets and Joys</span><span
                                    class="btn-arrow"><i class="fa fa-long-arrow-right"></i></span></a>

                            <div class="text">
                                <h4><img src="assets/images/home-new/PetsandjoysLogo.svg"
                                        alt="pets-and-joys" class="logo-brands"
                                        title="PetsandjoysLogo">
                                </h4>
                                <!-- <span>ecommerce website </span> -->
                                <h3 class="card-heading"><a routerLink="/case-studies/pets-and-joys.html"
                                        href="/case-studies/pets-and-joys">Pets and Joys
                                    </a></h3>
                            </div>
                        </div>
                    </ion-slide>
                    <ion-slide>
                        <div class="casestudy-single " 
                            style="visibility: visible; ">
                            <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Untitled%20design.jpg?alt=media&token=762989dc-c0a4-489a-a52d-57a860999645"
                                class="casestudy1" alt="ZonSteps">
                            <a class="read-more" routerLink="/case-studies/zonsteps.html" href="/case-studies/zonsteps"><span
                                    class="btn-text">ZonSteps</span><span class="btn-arrow"><i
                                        class="fa fa-long-arrow-right"></i></span></a>

                            <div class="text">
                                <h4><img src="assets/images/home-new/zonsteps.png" alt="zonsteps" class="logo-brands" title="zonsteps">
                                </h4>
                                <!-- <span>ecommerce website</span> -->
                                <h3 class="card-heading"><a routerLink="/case-studies/zonsteps.html"
                                        href="/case-studies/zonsteps">ZonSteps
                                    </a></h3>
                            </div>
                        </div>
                    </ion-slide>


                    <ion-slide class="inside-sl-box">
                        <div class="casestudy-single " 
                            style="visibility: visible; ">
                            <img src="assets/images/home-new/202315231654-183threndx.jpg" class="casestudy1" title="threndx"
                                alt="Threndx">
                            <a class="read-more" routerLink="/case-studies/threndx.html" href="/casestudy-details"><span
                                    class="btn-text">Threndx Story </span><span class="btn-arrow"><i
                                        class="fa fa-long-arrow-right"></i></span></a>

                            <div class="text">
                                <h4><img src="assets/images/home-new/threndx.png" alt="Threndx" title="threndx"
                                        class="logo-brands">
                                </h4>
                                <!-- <span>social media platform </span> -->
                                <h3 class="card-heading"><a routerLink="/case-studies/threndx.html"
                                        href="/casestudy-details">Threndx
                                    </a></h3>
                            </div>
                        </div>
                    </ion-slide>

                </ion-slides>
                <ion-button name="Previous" title="Previous" class="succprenext" (click)="slides.slidePrev()"> <i class="fa fa-angle-left"
                        aria-hidden="true"></i> </ion-button>
                <ion-button name="Next" title="Next" class="succprenext nextsucc" (click)="slides.slideNext()"> <i class="fa fa-angle-right"
                        aria-hidden="true"></i> </ion-button>
                <div class="col-sm-6 col-md-6 training transition">

                </div>
            </div>
        </div>
    </section>
</div>